import React from 'react';
import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Paper,
  Chip,
  Stack,
  Divider,
} from '@mui/material';
import {
  LocalShipping as ShippingIcon,
  Inventory as InventoryIcon,
  CheckCircle as CheckCircleIcon,
  HourglassEmpty as HourglassIcon,
  Cancel as CancelIcon,
  Assignment as AssignmentIcon,
} from '@mui/icons-material';

const OrderStatusTimeline = ({ order }) => {
  if (!order?.isInKind) return null;

  const statusIcons = {
    Dispatched: <InventoryIcon />,
    InTransit: <ShippingIcon />,
    Delivered: <CheckCircleIcon />,
    Received: <CheckCircleIcon />,
    Cancelled: <CancelIcon />,
  };

  const statusColors = {
    Dispatched: 'info',
    InTransit: 'warning',
    Delivered: 'success',
    Received: 'success',
    Cancelled: 'error',
  };

  const statusDescriptions = {
    Dispatched: 'The order has been dispatched from the warehouse',
    InTransit: 'The order is in transit to the cooperative',
    Delivered: 'The order has been delivered to the cooperative',
    Received: 'The order has been received and confirmed by the cooperative',
    Cancelled: 'The order has been cancelled',
  };

  const statuses = ['Dispatched', 'InTransit', 'Delivered', 'Received'];
  const currentStatus = order?.inKindStatus;
  const activeStep = statuses.indexOf(currentStatus);

  return (
    <Paper elevation={0} sx={{ p: 3, mb: 3, border: '1px solid', borderColor: 'divider' }}>
      <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
        <AssignmentIcon color="primary" />
        <Typography variant="h6" fontWeight="bold">
          In-Kind Order Status Timeline
        </Typography>
        <Chip 
          label={order?.isInKind ? "In-Kind Order" : "Regular Order"} 
          color={order?.isInKind ? "primary" : "default"}
          variant="outlined"
        />
      </Stack>
      
      <Divider sx={{ mb: 3 }} />
      
      <Stepper activeStep={activeStep + 1} orientation="vertical">
        {statuses.map((status, index) => {
          const isCompleted = index <= activeStep;
          const isActive = index === activeStep;
          
          return (
            <Step key={status} completed={isCompleted} active={isActive}>
              <StepLabel 
                icon={statusIcons[status]}
                optional={
                  <Typography variant="caption">
                    {statusDescriptions[status]}
                  </Typography>
                }
              >
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography variant="subtitle1" fontWeight="medium">
                    {status}
                  </Typography>
                  {isActive && (
                    <Chip 
                      label="Current" 
                      size="small" 
                      color="primary" 
                      variant="outlined" 
                    />
                  )}
                </Stack>
              </StepLabel>
              <StepContent>
                {order?.[`${status.toLowerCase()}Notes`] && (
                  <Paper variant="outlined" sx={{ p: 2, mt: 1 }}>
                    <Typography variant="body2" color="text.secondary">
                      <strong>Notes:</strong> {order[`${status.toLowerCase()}Notes`]}
                    </Typography>
                  </Paper>
                )}
              </StepContent>
            </Step>
          );
        })}
      </Stepper>
    </Paper>
  );
};

export default OrderStatusTimeline;